import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// this can be completed with other Transaction attributes
interface Transaction {
  confirmationId: number | null
  confirmationToken: string | null
}

const initialState: Transaction = {
  confirmationId: null,
  confirmationToken: null,
}

export const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    setTransactionId: (state, action: PayloadAction<number>) => {
      state.confirmationId = action.payload
    },
    setTransactionToken: (state, action: PayloadAction<string>) => {
      state.confirmationToken = action.payload
    },
  },
})

export const { setTransactionId, setTransactionToken } = transactionSlice.actions

export default transactionSlice.reducer
